import { OrganizationKeyName } from "../../../model/Organization";
import { AdminErrorListResponseData } from "../../../service/api-response/AdminFormErrorResponse";

export const UPSERT_NEWS_FAIL = "SHOP:UPSERT_NEWS_FAIL";

export const upsertNewsFailAction = (
  organization: OrganizationKeyName,
  errors: AdminErrorListResponseData,
  id?: string
) => ({
  type: UPSERT_NEWS_FAIL as typeof UPSERT_NEWS_FAIL,
  organization,
  errors,
  id,
});

export type UpsertNewsFailAction = ReturnType<typeof upsertNewsFailAction>;
